import React from 'react';
import { Container, Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../utils/AuthContext';

function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-vh-100 bg-light">
      <Navbar bg="white" expand="lg" className="shadow-sm mb-4" style={{ padding: '0.75rem 3rem' }}>
        <Container>
          <Navbar.Brand as={Link} to="/dashboard" className="fw-bold d-flex align-items-center" style={{ gap: '12px' }}>
            <img
              src="https://www.wishfin.com/images/home-page/wishfin-logo.svg"
              alt="Wishfin HRMS"
              height="40"
              className="d-inline-block"
            />
            <span style={{
              fontSize: '20px',
              color: '#2c3e50',
              letterSpacing: '-0.5px',
              borderLeft: '2px solid #e0e0e0',
              paddingLeft: '12px'
            }}>
              BugTracker
            </span>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto ms-4">
              <Nav.Link as={Link} to="/dashboard" className="px-3">
                <i className="bi bi-speedometer2 me-2"></i>
                Dashboard
              </Nav.Link>
              <Nav.Link as={Link} to="/projects" className="px-3">
                <i className="bi bi-folder me-2"></i>
                Projects
              </Nav.Link>
              <Nav.Link as={Link} to="/bugs" className="px-3">
                <i className="bi bi-bug-fill me-2"></i>
                Bugs
              </Nav.Link>
              {user?.role === 'Admin' && (
                <Nav.Link as={Link} to="/users" className="px-3">
                  <i className="bi bi-people-fill me-2"></i>
                  Users
                </Nav.Link>
              )}
            </Nav>
            <Nav>
              <NavDropdown
                title={
                  <span>
                    {user?.avatar_url && (
                      <img
                        src={user.avatar_url}
                        alt={user.full_name}
                        className="rounded-circle me-2"
                        width="32"
                        height="32"
                        style={{ objectFit: 'cover' }}
                      />
                    )}
                    <span style={{ fontWeight: '500' }}>{user?.full_name}</span>
                  </span>
                }
                align="end"
              >
                <NavDropdown.Item disabled>
                  <small className="text-muted">Role: {user?.role}</small>
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={handleLogout}>
                  Logout
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <main>{children}</main>
    </div>
  );
}

export default Layout;
